(() => {
  const update = (root, value) => {
    root.style.setProperty('--progress', `${value}%`);
    root.style.setProperty('--amount', String(Number(value) / 100));
    const output = root.querySelector('[data-demo-vlt]');
    const selected = root.querySelector('[data-demo-color][aria-pressed="true"]');
    if (!output || !selected) return;
    const clearText = selected.dataset.vltClear || '';
    const darkText = selected.dataset.vltDark || '';
    const clear = Number(clearText.replace(',', '.'));
    const dark = Number(darkText.replace(',', '.'));
    const valid = clearText.trim() && darkText.trim() && Number.isFinite(clear) && Number.isFinite(dark) && clear >= dark && clear <= 100 && dark >= 0;
    output.hidden = !valid;
    const slider = root.querySelector('input[type="range"]');
    if (!valid) { slider.removeAttribute('aria-valuetext'); return; }
    const vlt = clear + (dark - clear) * Number(value) / 100;
    const formatted = new Intl.NumberFormat(document.documentElement.lang || 'fr', { maximumFractionDigits: 1 }).format(vlt);
    output.textContent = `VLT ${formatted} %`;
    slider.setAttribute('aria-valuetext', output.textContent);
  };
  document.addEventListener('input', (event) => {
    const root = event.target.closest('[data-spkv3-demo]');
    if (root && event.target.matches('input[type="range"]')) update(root, event.target.value);
  });
  const requests = new WeakMap();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-demo-color]');
    if (!button) return;
    const root = button.closest('[data-spkv3-demo]');
    const request = {};
    requests.set(root, request);
    const light = document.importNode(button.querySelector('template[data-light]').content, true);
    const dark = document.importNode(button.querySelector('template[data-dark]').content, true);
    const images = [...light.querySelectorAll('img'), ...dark.querySelectorAll('img')];
    images.forEach(image => { image.loading = 'eager'; });
    try {
      await Promise.all(images.map(image => image.decode()));
    } catch { return; }
    if (requests.get(root) !== request || !root.isConnected) return;
    root.querySelectorAll('[data-demo-color]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    root.querySelector('[data-demo-light]').replaceChildren(light);
    root.querySelector('[data-demo-dark]').replaceChildren(dark);
    update(root, root.querySelector('input[type="range"]').value);
  });
  const initialize = (scope) => scope.querySelectorAll('[data-spkv3-demo]').forEach(root => {
    const slider = root.querySelector('input[type="range"]');
    if (slider) update(root, slider.value);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
